import { Injector, Pipe, PipeTransform, Type } from "@angular/core";

export type PIPE = {
  pipe: Type<any>;
  pipeArgs?: any;
};

@Pipe({
  name: "dynamicPipe",
  standalone: true,
})
export class DynamicPipePipe implements PipeTransform {
  constructor(private injector: Injector) {}

  /**
   * @param localeKey Optional ngx-translate language code. When it changes, the
   * pure pipe re-runs so locale-aware pipes (e.g. LocalizedDatePipe) refresh.
   */
  transform(
    value: any,
    pipes: PIPE[] | undefined,
    localeKey?: string,
  ): any {
    void localeKey;

    if (!pipes || (pipes && !pipes.length)) {
      return value;
    }
    const injector = Injector.create({
      name: "DynamicPipe",
      parent: this.injector,
      providers: pipes.map((p) => {
        return {
          provide: p.pipe,
        };
      }),
    });
    let v = value;
    pipes.forEach((p) => {
      const pipe = injector.get(p.pipe);

      if (Array.isArray(p.pipeArgs)) {
        try {
          v = pipe.transform(v, ...p.pipeArgs);
        } catch (error) {
          throw new Error(
            `${p.pipe.name} is not a Pipe or you cant't use this pipe, ${error}`,
          );
        }
      } else {
        try {
          v = pipe.transform(v, p.pipeArgs);
        } catch (error) {
          throw new Error(
            `${p.pipe.name} is not a Pipe or you cant't use this pipe, ${error}`,
          );
        }
      }
    });
    return v;
  }
}
